__turbopack_context__.v({
  "root": "VisuallyHidden-module__nh8oaG__root",
});
